import React, { useContext } from 'react'
import { TableContainer, Table, TableRow, TableHead, TableBody, TableCell, TableFooter, TablePagination, Divider, Menu, MenuItem } from '@material-ui/core'
import IconButton from '@material-ui/core/IconButton';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { FirebaseService, FirebaseConfigKey } from '../../../services/FirebaseService'
import SimpleAccordion from '../../Core/Expansion/SimpleAccordion'
import { TextButton } from '../../Core/Buttons/TextButton'
import FlexView from 'react-flexview/lib'
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import dayjs from 'dayjs'
import { useHistory } from 'react-router-dom';
var classNames = require('classnames')

export const RecentSubmissionTableRow = ({quote, onQuoteClick, options}) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    let quoteUrl = undefined;
    if (quote && quote.latestQuote && quote.latestQuote.quote_document_url) {
        quoteUrl = quote.latestQuote.quote_document_url;
    } 

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleClose = (choice) => {
      setAnchorEl(null);
    };

    const handleOpenQuoteDoc = () => {
        handleClose();
        window.open(quoteUrl, '_blank');
    }

    const handleOpenQuoteFlow = () => {
        handleClose();
        onQuoteClick(quote);
    }

    const onMenuItemClick = (option) => {
        handleClose();
        option.onClick();
    }

    let date = null;
    switch(quote.status) {
        case 'Created':
            date = quote.dateAdded ? dayjs(quote.dateAdded).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)) : 'N/A';
            break;
        case 'Quoted':
            date = quote.latestQuote ? dayjs(quote.latestQuote.date_added).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)) : 'N/A';
            break;
        default:
            date = 'N/A';

    }

    //const date = quote.latestQuote ? dayjs(quote.latestQuote.date_added).format(FirebaseService.getValue(FirebaseConfigKey.LONG_DATE_FORMAT)) : 'N/A';

    return (
        <TableRow onClick={handleOpenQuoteFlow} className="clickable" key={quote.id}>
            <TableCell component="th" scope="row">{quote.name}</TableCell>
            <TableCell>{quote.email}</TableCell>
            <TableCell>{date}</TableCell>
            <TableCell>{quote.status}</TableCell>
            <TableCell onClick={e => e.stopPropagation()}>
                <IconButton onClick={handleClick}>
                    <MoreVertIcon />
                </IconButton>
                <Menu
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}>
                            { quoteUrl && <MenuItem onClick={handleOpenQuoteDoc}>View last quote</MenuItem> }
                            <MenuItem onClick={handleOpenQuoteFlow}>Edit / Bind quote</MenuItem>
                            { options.map((option) => (
                                <MenuItem key={option.text} onClick={() => onMenuItemClick(option)}>
                                    {option.text}
                                </MenuItem>
                            ))}
                </Menu>
            </TableCell>
        </TableRow>
    )
}
